import React from "react";

function IconLaunchpad() {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, React.createElement("circle", {
    cx: "20",
    cy: "20",
    r: "20",
    fill: "#E1E5E9"
  }), React.createElement("path", {
    fill: "#576474",
    d: "M20.053 17.5a1.862 1.862 0 100-3.723 1.862 1.862 0 000 3.723z"
  }), React.createElement("path", {
    fill: "#576474",
    d: "M26.457 16.977v-.744c0-6.032-5.809-9.01-6.106-9.16-.15-.074-.373-.074-.596 0-.223.15-6.032 3.128-6.106 9.16v.744c-.745.82-3.649 4.096-3.649 7.521 0 .372.298.67.67.67h3.277c.149.373.372.745.67.969l2.16 2.159c.148.149.297.223.446.223h5.734c.149 0 .372-.074.447-.223l2.16-2.16c.297-.297.52-.595.67-.968h3.276c.372 0 .67-.297.67-.67-.075-3.425-2.979-6.702-3.723-7.52zm-12.808 2.01v4.841H11.34c.224-1.862 1.415-3.649 2.309-4.84zm10.946 6.256l-1.936 1.936h-5.212l-2.011-2.01a1.797 1.797 0 01-.521-1.267v-7.744c0-4.542 3.946-7.148 5.063-7.819 1.117.67 5.064 3.277 5.064 7.82v7.744c.074.52-.075.968-.447 1.34zm1.862-1.415v-4.84c.893 1.191 2.085 2.978 2.308 4.84h-2.308zM20.053 32.69c-.596-.52-1.713-1.786-1.713-3.35H17c0 2.83 2.532 4.617 2.68 4.691.15.075.224.15.373.15a.569.569 0 00.372-.15c.075-.074 2.681-1.936 2.681-4.691h-1.34c.074 1.638-1.117 2.83-1.713 3.35z"
  }));
}

export default IconLaunchpad;